import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import style from './form-field.scss';

@CSSModules(style)
export default class FormField extends Component {
  static childContextTypes = {
    formFieldName: PropTypes.string,
    formFieldLabel: PropTypes.string,
    setType: PropTypes.func
  };

  static contextTypes = {
    errors: PropTypes.object
  };

  state = {};

  getChildContext() {
    return {
      formFieldName: this.props.name,
      formFieldLabel: this.props.label,
      setType: ::this.setType
    }
  }

  setType(type, props) {
    this.setState({ childType: type, childProps: props });
  }

  get errors() {
    return (this.context.errors || {})[this.props.name];
  }

  render() {
    const { childType } = this.state;
    const { children, label, style } = this.props;
    const hasLabel = childType !== 'CheckBox' && childType !== 'RadioBox' && childType !== 'SwitchButton' ? !!this.props.label : '' ;
    const _element = hasLabel ? 'label' : 'div';

    return (
      <div styleName="root" style={style}>
        <_element>
          {hasLabel ? <span styleName="label">{label}</span> : null}
          {children}
          {this.errors ? (
            <span styleName="errors">{this.errors.join(', ')}</span>
          ) : null}
        </_element>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/form-field.js